import { render, staticRenderFns } from "./CustomerExcludeDialog.vue?vue&type=template&id=323b5146&scoped=true"
import script from "./CustomerExcludeDialog.vue?vue&type=script&lang=js"
export * from "./CustomerExcludeDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerExcludeDialog.vue?vue&type=style&index=0&id=323b5146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323b5146",
  null
  
)

export default component.exports